import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from "rxjs/operators";

import { AuthService } from 'src/app/_services/auth.service';
import { AlertService } from './alert.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private _authService: AuthService,
    private _alertService: AlertService
  ) { }

  /**
   * Intercept
   *
   * @param req
   * @param next
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request object
    let newReq = req.clone();

    if (this._authService.accessToken) {
      newReq = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + this._authService.accessToken)
      });
    }

    // Response
    return next.handle(newReq).pipe(
      catchError((error) => {

        // Catch "401 Unauthorized" responses
        if (error instanceof HttpErrorResponse && error.status === 401) {

          // Log out
          this._authService.logout({ deviceId: this._authService.deviceId });

          // Reload the app
          location.reload();

        } else if (error instanceof HttpErrorResponse && (error.status === 500 || error.status === 400)) {

          // display errors
          this._alertService.showValidationErrors(error.error?.message);

        }

        // if any other error return it to calling api
        return throwError(() => new Error(error));
      })
    );
  }
}
